<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Deductions</h1>
    <p>We’ve set up a standard list of common deduction types that most companies use — such as healthcare, cycle-to-work schemes, or repayments. These are already included in your payroll setup by default.</p>
    <p>
      <a @click.prevent="showHelpPanel = !showHelpPanel">
        See our default deductions.
      </a>
    </p>
    <div class="help-panel" style="margin-bottom: 20px;" v-if="showHelpPanel" >
      <div style="float: right;"><button type="button" style="font-size: 40px; margin-top:-20px;" @click.prevent="showHelpPanel = !showHelpPanel">&times;</button></div>
      <h4>Default Payments</h4>
      <p>
        <ul>
          <li v-for="(deduction, idx) in defaultDeductions" :key="idx">
            {{ deduction }}
          </li>
        </ul>
      </p>
    </div>
    <p>However, if you have any additional deduction types that you use, please let us know so we can add them to your payroll setup.</p>
    <p>For each additional deduction type, we’ll need to understand how it should be treated for Tax, National Insurance, and Pension purposes, so we can ensure it’s processed correctly.</p>
    </div>

    <div class="cell small-12">
      <EditableTable
        v-model="formData.deductions"
        :columns="columns"
        :buttonName="'Add Additional Deduction'"
      />
    </div>



</template>


<script setup>

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';
import defaultDeductions from '@/helpers/arrays/defaultDeductions';
import EditableTable from '@/components/controls/EditableTable.vue'


const error = ref([]);

const route = useRoute();
const taskId = route.params.taskId;

const props = defineProps({
  formData: Object
})

const showHelpPanel = ref(false);

const columns = [
  { field: 'name', label: 'Deduction Name', type: 'text', placeholder: 'Enter deduction name' },
  { field: 'tax', label: 'Deducted Prior to Tax', type: 'checkbox' },
  { field: 'ni', label: 'Deducted Prior to NI', type: 'checkbox' },
  { field: 'pension', label: 'Deducted Prior to Pension', type: 'checkbox' }
]


const validateStep = () => {

  error.value = [];

  const nameMap = new Map();
  props.formData.deductions.forEach((deduction, idx) => {
    if (!deduction.name || !deduction.name.trim()) {
      error.value.push(`Deduction ${idx + 1} must have a name.`);
    }

    const name = (deduction.name || '').trim().toLowerCase();
    if (name) {
      if (nameMap.has(name)) {
        error.value.push(`Deduction ${idx + 1} has a duplicate name with Deduction ${nameMap.get(name) + 1}.`);
      } else {
        nameMap.set(name, idx);
      }
    }
  });



  if (error.value.length > 0) return false;


  return true;
}


import { putDataCollectionTask } from '@/services/implementationmanagement.api';
const executeStep = async () => {

  var payload = {
    version: 1,
    dataJson: JSON.stringify(props.formData),
    schemaName: "CompanyAdditionsDeductions",
    taskId: taskId,
    taskStatus: "SuccessfullyCompleted"
  }

  var response = await putDataCollectionTask(taskId, payload);

  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.';
    return false;
  }

  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>